<div class="input-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        class="close-button"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <form [formGroup]="inputForm" (ngSubmit)="onSubmit()">
    <!-- Modal Content -->
    <div class="modal-content">
      @if (data.message) {
        <p [innerHTML]="data.message"></p>
      }

      <mat-form-field class="full-width">
        <mat-label>{{ data.inputLabel || "Input" }}</mat-label>
        <input
          matInput
          [type]="
            data.inputType === 'password' && showPassword ? 'password' : 'text'
          "
          [placeholder]="data.inputPlaceholder || ''"
          formControlName="inputValue"
        />
        @if (data.inputType === "password") {
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="togglePasswordVisibility()"
          >
            <mat-icon>{{
              !showPassword ? "visibility" : "visibility_off"
            }}</mat-icon>
          </button>
        }
        @if (inputForm.get("inputValue")?.invalid) {
          <mat-error>
            @switch (true) {
              @case (inputForm.get("inputValue")?.errors?.["required"]) {
                <span> This field is required </span>
              }
              @case (inputForm.get("inputValue")?.errors?.["email"]) {
                <span> Please enter a valid email address </span>
              }
              @case (inputForm.get("inputValue")?.errors?.["pattern"]) {
                <span> Invalid format </span>
              }
              @case (inputForm.get("inputValue")?.errors?.["minlength"]) {
                <span> Minimum length is {{ data.inputMinLength }} </span>
              }
              @case (inputForm.get("inputValue")?.errors?.["maxlength"]) {
                <span> Maximum length is {{ data.inputMaxLength }} </span>
              }
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
      @if (data.confirmCaption) {
        <button
          class="confirm-button"
          type="submit"
          [disabled]="!inputForm.valid"
        >
          {{ data.confirmCaption }}
        </button>
      }
      @if (data.cancelCaption) {
        <button class="cancel-button" type="button" [mat-dialog-close]="false">
          {{ data.cancelCaption }}
        </button>
      }
    </div>
  </form>
</div>
